import { createSlice } from '@reduxjs/toolkit'
import { Html, Css, Javascript } from '@mui/icons-material';
import { FaBootstrap, FaCss3, FaHtml5, FaJs, FaLaravel, FaNodeJs, FaPhp, FaReact } from 'react-icons/fa';
const img1 = "./assets/images/partners/logo512.png";
const img2 = "./assets/images/partners/logo-full.png";
const html = '/assets/skills/html.png';
const css = '/assets/skills/css.png'
const laravel = '/assets/skills/laravel.png'
const mui = '/assets/skills/mui.png'
const react = '/assets/skills/react.png'
const php = '/assets/skills/php.png'
const bootstrap = '/assets/skills/bootstrap.png'
const jquery = '/assets/skills/jquery.png'
const js = '/assets/skills/js.png'
const nodejs = '/assets/skills/nodejs.png'
const tailwind = '/assets/skills/tailwind.png'

const partnersSlice = createSlice({
    name: 'partners',
    initialState: {
      payload: [
        {
          img: <FaHtml5 size={'100%'} color='#DE3409' />,
          image: html,
          title: 'HTML',
          color: '#DE3409'
        },
        {
          img: <FaCss3 size={'100%'} color='#2965f1' />,
          title: 'CSS',
          image: css,
          color: '#2965f1'
        },
        {
          img: <FaJs size={'100%'} color='#F1C736'/>,
          title: 'JAVASCRIPT',
          color: '#F1C736',
          image: js,
        },
        {
          img: <FaPhp size={'100%'} color={'#61dafb'} />,
          title: 'PHP',
          color: '#61dafb',
          image: php,
        },
        {
          img: <FaBootstrap size={'100%'} color='#4E0AA7'/>,
          title: 'JQuery',
          color: '#4E0AA7',
          image: jquery,
        },
        {
          img: <FaReact size={'100%'} color='#61DBFB' />,
          title: 'Reactjs',
          color: '#61DBFB',
          image: react,
        },
        {
          img: <FaNodeJs size={'100%'} color='#68a063 ' />,
          title: 'Nodejs',
          color: '#68a063 ',
          image: nodejs,
        },
        {
          img: <FaLaravel size={'100%'} color='#DB041A'/>,
          title: 'Laravel',
          color: '#DB041A',
          image: laravel,
        }
      ]
    }
    ,
    reducers: {
        partners: (state, action) => {
            state.sliders = action.payload;
        }
    }
})

export const {partners} = partnersSlice.actions;
export default partnersSlice.reducer;
